import {
  BrowserRouter as Router,
  Route,
  Routes,
  //Navigate,
} from "react-router-dom";
import { CurrencyProvider } from "./context/CurrencyContext";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword.tsx";
import PasswordVerification from "./pages/passwordVerification/PasswordVerification.tsx";
import NewPassword from "./pages/newPassword/NewPassword.tsx";
import Register from "./pages/register/Register.tsx";
import HomePage from "./pages/homePage/HomePage.tsx";
import SupplierApplicationForm from "./pages/supplierApplicationForm/ supplierApplicationForm.tsx";
import SupplierVerification from "./pages/supplierVerification/SupplierVerification.tsx";
import SupplierInformation from "./pages/supplierInformation/SupplierInformation.tsx";
import Profile from "./pages/profile/Profile.tsx";
import EditProfile from "./components/editProfile/EditProfile.tsx";
import Favorites from "./components/favorites/Favorites.tsx";
import Orders from "./components/orders/Orders.tsx";
import Settings from "./components/settings/Settings.tsx";
import SpecialOffers from "./components/specialOffers/SpecialOffers.tsx";
import OrderDetail from "./components/orderDetail/OrderDetail.tsx";
import AboutUs from "./pages/aboutUs/AboutUs.tsx";
import Support from "./components/support/Support.tsx";
import Basket from "./pages/basket/Basket.tsx";
import CategoriesDetail from "./pages/categoriesDetail/CategoriesDetail.tsx";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CompanyCampaigns from "./pages/companyCampaigns/companyCampaigns.tsx";
import DailyCampaign from "./pages/dailyCampaigns/dailyCampaign.tsx";
import WeeklyCampaigns from "./pages/weeklyCampaigns/WeeklyCampaigns.tsx";
import SafePayment from "./pages/safePayment/SafePayment.tsx";
import LastOrders from "./pages/lastOrders/LastOrders.tsx";
import EPara from "./pages/ePara/ePara.tsx";
import CampaignDetail from "./pages/campaignDetail/CampaignDetail.tsx";
import AdsDetail1 from "./pages/adsDetail1/AdsDetail1.tsx";
import AdsDetail2 from "./pages/adsDetail2/AdsDetail2.tsx";
import SupplierPage from "./pages/supplierPage/SupplierPage.tsx";
import CompanyCamp from "./pages/companyCamp/CompanyCamp.tsx";
import CompanyCampProductList from "./pages/companyCampProductList/companyCampProductList.tsx";
import ProductDetail from "./pages/productDetail/ProductDetail.tsx";
import { UserProvider } from "./context/UserContext.tsx";
import Contracts from "./pages/contracts/Contracts.tsx";
import AllContracts from "./pages/contracts/AllContracts.tsx";
import DailyCampaignDetail from "./pages/dailyCampaigns/dailyCampaignDetail.tsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ProductProvider } from "./context/ProductContext.tsx";
import Academy from "./pages/academy/Academy.tsx";
import Complain from "./pages/complain/complain.tsx";
import ProductCategories from "./pages/products/ProductCategories.tsx";
import { NavbarProvider } from "./context/NavbarContext.tsx";
import ComplainDetail from "./pages/complainDetail/complainDetail.tsx";
import { LanguageProvider } from "./context/LanguageContext.tsx";
import InfoPay from "./pages/pay/InfoPay.tsx";
import Layout from "./layout/Layout.tsx";
import { HelmetProvider } from "react-helmet-async";
import MapComponent from "./components/map/MapComponent.tsx";
import StartPage from "./pages/StartPage.tsx";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

/* THIS AREA IS FOR ONLY NOVAMEDSHOP.COM */

/*const RedirectToStart = () => {
  const location = useLocation();
  const hasRedirected = sessionStorage.getItem("hasRedirected");

  useEffect(() => {
    if (!hasRedirected && location.pathname === "/") {
      sessionStorage.setItem("hasRedirected", "true");
    }
  }, [hasRedirected, location.pathname]);

  if (!hasRedirected && location.pathname === "/") {
    return <Navigate to="/start" replace />;
  }

  return null;
};*/

function App() {

  return (
    <HelmetProvider>
      <CurrencyProvider>
        <LanguageProvider>
          <UserProvider>
            <ProductProvider>
              <NavbarProvider>
                <Router>
                  <GoogleOAuthProvider
                    clientId={
                      process.env.REACT_APP_GOOGLEAPI
                        ? process.env.REACT_APP_GOOGLEAPI
                        : ""
                    }
                  >
                    <ScrollToTop />
                    {/* <RedirectToStart /> */}
                    <Routes>
                      <Route path="/start" element={<StartPage />} />
                      <Route element={<Layout children={""} />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/profile/*" element={<Profile />} />
                        <Route path="/edit" element={<EditProfile />} />
                        <Route path="/favorites" element={<Favorites />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/special" element={<SpecialOffers />} />
                        <Route
                          path="/forgot-password"
                          element={<ForgotPassword />}
                        />
                        <Route
                          path="/password-verification"
                          element={<PasswordVerification />}
                        />
                        <Route path="/new-password" element={<NewPassword />} />
                        <Route path="/register" element={<Register />} />
                        <Route
                          path="/supplier-application-form"
                          element={<SupplierApplicationForm />}
                        />
                        <Route
                          path="/supplier-verification"
                          element={<SupplierVerification />}
                        />
                        <Route
                          path="/supplier-information"
                          element={<SupplierInformation />}
                        />
                        <Route
                          path="/contracts/:contractType"
                          element={<Contracts />}
                        />
                        <Route path="/complain/:id" element={<Complain />} />
                        <Route
                          path="/complain-detail"
                          element={<ComplainDetail />}
                        />
                        <Route path="/info-pay" element={<InfoPay />} />
                        <Route
                          path="/product-categories/:catId"
                          element={<ProductCategories />}
                        />
                        <Route path="/order-detail" element={<OrderDetail />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/basket" element={<Basket />} />
                        <Route
                          path="/categories/:subCategoryName"
                          element={<CategoriesDetail />}
                        />
                        <Route
                          path="/company-campaigns"
                          element={<CompanyCampaigns />}
                        />
                        <Route
                          path="/daily-campaigns"
                          element={<DailyCampaign />}
                        />
                        <Route
                          path="/daily-campaign/:id"
                          element={<DailyCampaignDetail />}
                        />
                        <Route
                          path="/weekly-campaigns"
                          element={<WeeklyCampaigns />}
                        />
                        <Route path="/safe-payment" element={<SafePayment />} />
                        <Route path="/last-orders" element={<LastOrders />} />
                        <Route path="/epara" element={<EPara />} />
                        <Route
                          path="/company-campaigns/company-camp/campaign-detail/:id"
                          element={<CampaignDetail />}
                        />
                        <Route
                          path="/ads-detail-1/:id"
                          element={<AdsDetail1 />}
                        />
                        <Route
                          path="/ads-detail-2/:id"
                          element={<AdsDetail2 />}
                        />
                        <Route
                          path="/supplier-page"
                          element={<SupplierPage />}
                        />
                        <Route
                          path="/company-campaigns/company-camp/:supplierId"
                          element={<CompanyCamp />}
                        />
                        <Route
                          path="/company-camp-product-list/:id"
                          element={<CompanyCampProductList />}
                        />
                        <Route
                          path="/product-detail/:productId"
                          element={<ProductDetail />}
                        />
                        <Route
                          path="/all-contracts/"
                          element={<AllContracts />}
                        />
                        <Route path="/map" element={<MapComponent />} />
                        <Route path="/academy/*" element={<Academy />} />
                      </Route>
                    </Routes>
                  </GoogleOAuthProvider>
                </Router>
              </NavbarProvider>
            </ProductProvider>
          </UserProvider>
        </LanguageProvider>
      </CurrencyProvider>
    </HelmetProvider>
  );
}

export default App;
